import { useEffect, useState } from "react";
import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Select,
    MenuItem,
    Button,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { errorToast } from "../../helpers";
import Pagination from "../../components/Pagination";

import moment from "moment";

import { useLazyGetSubscriptionHistoryQuery } from "../../services/users";

const SubscriptionHistory = () => {


    const [transactionsApi, { isLoading }] = useLazyGetSubscriptionHistoryQuery();
    const { _id } = useParams();
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    let totalPages = Math.ceil(totalCount / limit);
    const [records, setRecords] = useState<any[]>([]);

    const onPageChange = (newPage: number) => {
        setPage(newPage);
        setRecords([]);
    };


    const fetchApi = async () => {
        try {
            const response = await transactionsApi({ page: page, userId: _id, limit: limit }).unwrap();
            setRecords(response?.data || [])
            setTotalCount(response?.data?.count);
        } catch (e: any) {
            errorToast(e?.data?.message);
        }
    };



    function formatNumberWithCommas(value: string | number) {
        const valueStr = typeof value === 'number' ? value.toFixed(2) : value;
        const [integer, decimal] = valueStr.split('.');
        const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        let result = decimal !== undefined ? `${formattedInteger}.${decimal}` : formattedInteger;
        return result;
    }



    useEffect(() => {
        if (_id) {
            fetchApi()
        }
    }, [page, limit]);

    return (
        <>
            <Card className="cards">

                <TableContainer className="table_container">
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">S.No</TableCell>
                                <TableCell>Subscription Name</TableCell>
                                <TableCell>Start Date</TableCell>
                                <TableCell>End Date</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Subscription Type</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {records?.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        No History found
                                    </TableCell>
                                </TableRow>
                            ) : (
                                records?.map((item: any, index: number) => (
                                    <TableRow key={item?._id}>
                                        <TableCell align="center">{(page - 1) * 10 + index + 1}</TableCell>

                                        <TableCell>
                                            {item?.subscriptionId?.name || "-"}
                                        </TableCell>
                                        <TableCell>
                                            {item?.subscriptionStartDate ? moment(item?.subscriptionStartDate).format("LLL") : "-"}
                                        </TableCell>
                                        <TableCell>
                                            {item?.subscriptionEndDate ? moment(item?.subscriptionEndDate).format("LLL") : "-"}
                                        </TableCell>
                                        <TableCell>
                                            AED {formatNumberWithCommas(item?.price) || "-"}
                                        </TableCell>
                                        <TableCell>
                                            {item?.isActive ? "Active" : "Inactive"}
                                        </TableCell>

                                        <TableCell>{item?.subscriptionType === 1 ? "Trial Subscription" : "Normal Subscription"}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card> {records?.length ? (
                <Pagination
                    limit={limit}
                    setLimit={setLimit}
                    setPage={setPage}
                    module={records}
                    page={page}
                    onPageChange={onPageChange}
                    totalPages={totalPages}
                />
            ) : (
                ""
            )}
        </>
    );
};

export default SubscriptionHistory;
